var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180.51 180.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.17,90.25L178.08,24.35c3.24-3.24,3.24-8.49,0-11.73l-10.19-10.19c-3.24-3.24-8.49-3.24-11.73,0l-65.9,65.9L24.35,2.43c-3.24-3.24-8.49-3.24-11.73,0L2.43,12.62c-3.24,3.24-3.24,8.49,0,11.73l65.9,65.9L2.43,156.16c-3.24,3.24-3.24,8.49,0,11.73l10.19,10.19c3.24,3.24,8.49,3.24,11.73,0l65.9-65.9,65.9,65.9c3.24,3.24,8.49,3.24,11.73,0l10.19-10.19c3.24-3.24,3.24-8.49,0-11.73l-65.9-65.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e6059e9975ec1bc5ec360fe9b86a28f9.svg";
export { ForwardRef as ReactComponent };